import { Radio, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import { PaymentMethodApplePay, PaymentMethodApplePayRedesigned } from '../PaymentMethodApplePay'
import { useApplePayTooltip } from '../PaymentMethodApplePay/useApplePayTooltip'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import React, { FC } from 'react'
import { SupportedNewPaymentType } from './types'

interface ApplePayOptionProps {
  toggleTooltip: () => void
}

const ApplePayOption: FC<ApplePayOptionProps> = ({ toggleTooltip }) => {
  const id = 'apple-pay-learn-more-tooltip'
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  return (
    <div className={styles.applePayHeading}>
      <div className={styles.container}>
        {isArcadeDesignLanguage ? (
          <PaymentMethodApplePayRedesigned
            showLearnMore
            handleToggleTooltip={toggleTooltip}
            testNameSpace='payment-method-applepay-heading'
            ariaDescribedBy={id}
          />
        ) : (
          <PaymentMethodApplePay
            showLearnMore
            handleToggleTooltip={toggleTooltip}
            testNameSpace='payment-method-applepay-heading'
            iconSize='Medium'
            ariaDescribedBy={id}
          />
        )}
      </div>
    </div>
  )
}

interface ApplePayPaymentOptionProps {
  selectedPaymentMethod: SupportedNewPaymentType
  setPaymentMethod: (method: SupportedNewPaymentType) => void
  toggleTooltipClassic: () => void
  closeTooltipClassic: () => void
}

export const ApplePayPaymentOption: FC<ApplePayPaymentOptionProps> = ({
  selectedPaymentMethod,
  setPaymentMethod,
  closeTooltipClassic,
  toggleTooltipClassic,
}) => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { tooltipTriggerRef, openTooltip } = useApplePayTooltip()
  const { radioSize } = useCheckoutSizes()
  return (
    <Radio.Button
      labelWidth='Full'
      itemRef={isArcadeDesignLanguage ? tooltipTriggerRef : undefined}
      size={radioSize}
      checked={selectedPaymentMethod === 'applePay'}
      label={() => <ApplePayOption toggleTooltip={isArcadeDesignLanguage ? openTooltip : toggleTooltipClassic} />}
      labelPlacement={isArcadeDesignLanguage ? 'Top' : 'Middle'}
      kind={isArcadeDesignLanguage ? 'Option' : 'Default'}
      indent={!isArcadeDesignLanguage}
      icon={isArcadeDesignLanguage ? 'Default' : 'Select'}
      reversed={isArcadeDesignLanguage}
      value='applePay'
      onChange={() => {
        setPaymentMethod('applePay')
        if (!isArcadeDesignLanguage) {
          closeTooltipClassic()
        }
      }}
      testNameSpace='applePay'
    />
  )
}
